import $ from 'jquery';
import MicroEvent from 'microevent';

type CurrentTrack = { url: string } | undefined;

class AudioManager {
  declare player: HTMLAudioElement | null;
  declare playlist: string[];

  // Added by MicroEvent
  declare trigger: (name: string, value: CurrentTrack) => unknown;
  declare bind: (
    name: string,
    callback: (event: CurrentTrack) => unknown
  ) => unknown;

  constructor() {
    this.onPause = this.onPause.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.onEnd = this.onEnd.bind(this);
  }

  play(): void {
    this.player?.play();
  }

  currentTrack(): CurrentTrack {
    if (!this.player) return;
    return { url: this.player.src };
  }

  playing(): boolean {
    return Boolean(this.player && !this.player.paused);
  }

  pause(): void {
    this.player?.pause();
  }

  createPlayer(url: string): void {
    if (this.player) {
      this.player.pause();
      this.trigger('pause', this.currentTrack());
    }
    this.player = new Audio(url);
    this.player.addEventListener('pause', this.onPause);
    this.player.addEventListener('ended', this.onPause);
    this.player.addEventListener('play', this.onPlay);
    this.player.addEventListener('playing', this.onPlay);
    this.player.addEventListener('ended', this.onEnd);
  }

  start(playlist: string[]): void {
    this.playlist = playlist.slice();
    this.next();
  }

  next(): void {
    const nextSong = this.playlist.shift();
    if (nextSong) {
      this.createPlayer(nextSong);
      return this.play();
    }
  }

  onPause(): void {
    this.trigger('pause', this.currentTrack());
  }

  onPlay(): void {
    this.trigger('play', this.currentTrack());
  }

  onEnd(): void {
    this.next();
  }
}

MicroEvent.mixin(AudioManager);

function initializePlayButtons(): void {
  const previews = $('.js-audio');
  const playlists = $('.js-playlist');
  const manager = new AudioManager();
  document.audioManager = manager;

  previews.each(function (index, previewEl) {
    const preview = $(previewEl);

    const stopped = function (): void {
      container.removeClass('playing');
      preview.removeClass('playing');
    };
    const started = function (): void {
      container.addClass('playing');
      preview.addClass('playing');
    };

    const container = $(preview).parent().parent();
    const url = preview.data('url');
    const list = preview
      .closest('.tracklist-track')
      .find('~.tracklist-track .js-audio')
      .map((index, element) => $(element).data('url'))
      .toArray();
    list.unshift(url);

    manager.bind('play', function (event) {
      if (url === event?.url) {
        return started();
      }
    });

    manager.bind('pause', function (event) {
      if (url === event?.url) {
        return stopped();
      }
    });

    preview.on('click', function (event) {
      event.preventDefault();
      if (manager.currentTrack()?.url === url && manager.playing()) {
        return manager.pause();
      } else {
        return manager.start(list);
      }
    });
  });

  playlists.each(function (index, playlistEl): void {
    const playlist = $(playlistEl);

    const stopped = (): void => {
      playlist.removeClass('playing');
    };
    const started = (): void => {
      playlist.addClass('playing');
    };

    const tracks = playlist
      .closest('.js-sampleContainer')
      .find('.js-audio')
      .map((index, element) => $(element).data('url'))
      .toArray();

    manager.bind('play', function (event) {
      if (tracks.includes(event?.url)) {
        return started();
      }
    });

    manager.bind('pause', function (event) {
      if (tracks.includes(event?.url)) {
        return stopped();
      }
    });

    playlist.on('click', function (event): void {
      const currentUrl = manager.currentTrack()?.url;

      event.preventDefault();
      if (tracks.includes(currentUrl) && manager.playing()) {
        manager.pause();
      } else {
        manager.start(tracks);
      }
    });
  });
}

$(document).on('ready turbo:load turbo:frame-load', initializePlayButtons);
